export enum Status {
  Requested = 'Requested',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Archived = 'Archived',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
}
